module.exports = __webpack_public_path__ + "img/Enacted.80e19c6d.svg";